module.exports = __webpack_public_path__ + "img/handicapped_person_recruitment.3ce1b1b.png";